import { render, staticRenderFns } from "./c_home_merchant.vue?vue&type=template&id=04485cf4&scoped=true"
import script from "./c_home_merchant.vue?vue&type=script&lang=js"
export * from "./c_home_merchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04485cf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04485cf4')) {
      api.createRecord('04485cf4', component.options)
    } else {
      api.reload('04485cf4', component.options)
    }
    module.hot.accept("./c_home_merchant.vue?vue&type=template&id=04485cf4&scoped=true", function () {
      api.rerender('04485cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_merchant.vue"
export default component.exports